import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../../../global/button/Button'
import { DialogModal } from '../DialogModal'
import { cloneButtonDesktop } from '../common/helpers/button'
import { CommonModalTitleProps, ModalProps } from '../types'

import styles from './FilterModalDesktop.module.scss'

interface FilterModalProps extends PropsWithChildren<CommonModalTitleProps & ModalProps> {
  isValid: boolean
  isLoading?: boolean
  onConfirm(): void
  onClear(): void
}

export const FilterModalDesktop: React.FC<FilterModalProps> = (props) => {
  const { title, children, isLoading, isValid, onConfirm, onClear, onClose } = props

  const { t } = useTranslation()

  return (
    <DialogModal
      title={title}
      isLoading={isLoading}
      renderFooter={() => [
        cloneButtonDesktop(
          <Button appearance='ghost' onClick={onClear}>
            {t('Clear All')}
          </Button>
        ),
        cloneButtonDesktop(
          <Button appearance='ghost' onClick={onConfirm} disabled={!isValid}>
            {t('Confirm')}
          </Button>
        ),
      ]}
      onClose={onClose}
    >
      <section className={styles.body}>{children}</section>
    </DialogModal>
  )
}
